import { IRequestResult } from "../api-client";
import { BaseApi } from "../base";

interface IAdressesResponseData {
  email: string;
}

interface IFetchAddressesParams {
  type: "requester" | "cc";
  fragment: string;
}

export default class AddressesApi extends BaseApi {
  protected readonly prefix = "addresses";

  fetchAddresses = ({ type, fragment }: IFetchAddressesParams): Promise<IRequestResult<IAdressesResponseData[]>> =>
    this.get("", { type, fragment });
}
